import { useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { FormDefinition } from "../types"
import { useMemo } from "react"
import { createSchema } from "../schema"
import { useOperation } from "@/modules/operations"

export interface CustomFormInput<T> {
  definition: FormDefinition<T>
  onSuccess?: () => void
  onError?: () => void
}

export const useCustomForm = <T>({
  definition,
  onError,
  onSuccess,
}: CustomFormInput<T>) => {
  const schema = useMemo(
    () => createSchema(definition.fields),
    [definition.fields]
  )

  const form = useForm({
    resolver: yupResolver(schema),
    defaultValues: definition.fields.reduce(
      (acc, field) => {
        if (field.defaultValue) {
          acc[field.name] = field.defaultValue
        }
        return acc
      },
      {} as Record<string, any>
    ),
  })

  const { invoke, state } = useOperation({
    operation: definition.submitAction,
    onError: () => {
      console.log("form submit error")
      onError?.()
    },
    onSuccess: () => {
      console.log("form submitted")
      for (const filed of definition.fields) {
        form.setValue(filed.name, "")
      }
      onSuccess?.()
    },
  })

  const handleSubmit = () => {
    form.handleSubmit((data) => {
      invoke(data as T)
    })()
  }

  return {
    handleSubmit,
    submitState: state,
    formState: form.formState,
    registerField: form.register,
  }
}
